export default __webpack_public_path__ + "static/media/ert_num_bg.6c04c4e8.png";